import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { useTranslation } from "react-i18next";
import LegalPageLayout from "./LegalPageLayout";
import TermsConditionsContent from "./TermsConditionsContent";

export default function TermsConditionsPage() {
  const { t } = useTranslation("home");

  const prefersReducedMotion = useReducedMotion();

  const contentVariants = {
    hidden: {
      opacity: 0,
      y: prefersReducedMotion ? 0 : 14,
    },

    visible: {
      opacity: 1,
      y: 0,

      transition: {
        duration: prefersReducedMotion ? 0.01 : 0.55,

        delay: prefersReducedMotion ? 0 : 0.2,

        ease: [0.22, 1, 0.36, 1],
      },
    },
  };

  return (
    <LegalPageLayout
      pageClassName="terms-conditions-page"
      kicker={t("legalPages.terms.kicker", "LEGAL INFORMATION")}
      title={t("legalPages.terms.title", "Terms & Conditions")}
      description={t(
        "legalPages.terms.description",
        "Terms governing access to and use of the LEG-UP platform.",
      )}
    >
      <motion.div
        className="legal-page__content"
        initial="hidden"
        animate="visible"
        variants={contentVariants}
      >
        <TermsConditionsContent />
      </motion.div>
    </LegalPageLayout>
  );
}
